import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import SEO from "../components/SEO";
 


function Cookies() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Cookiebeleid - elektricieninarnhem026.nl"
        description="Cookiebeleid voor elektricieninarnhem026.nl"
        image="/images/banner.png"
      />
      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
        <h1 className="font-bold text-black leading-[1.25] text-[28px] lg:text-[36px] text-[#17354A] block mb-4 leading-[35px] text-[2rem] md:inline-block md:mb-5 md:text-[44px] md:leading-[42px] lg:block">
          Cookiebeleid
        </h1>

        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] mb-8">
          <p>
            elektricieninarnhem026.nl gebruikt cookies om uw ervaring op onze website
            te verbeteren. In dit cookiebeleid leggen we uit welke cookies we
            gebruiken en waarom.
          </p>

          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6 mt-12">
            Wat zijn cookies?
          </h2>
          <p>
            Cookies zijn kleine tekstbestanden die op uw computer of mobiele
            apparaat worden opgeslagen wanneer u onze website bezoekt. Deze
            bestanden maken het mogelijk om uw voorkeuren te onthouden en de
            website beter te laten functioneren.
          </p>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Welke cookies gebruiken we?
          </h2>

          <h3 className="font-bold text-[20px] text-[#17354A] mt-8 mb-4">
            Noodzakelijke cookies
          </h3>
          <p>
            Deze cookies zijn essentieel voor het functioneren van de website.
            Ze onthouden bijvoorbeeld uw voorkeuren en sessie-informatie.
          </p>

          <h3 className="font-bold text-[20px] text-[#17354A] mt-8 mb-4">
            Analytische cookies
          </h3>
          <p>
            We gebruiken analytische cookies om te begrijpen hoe bezoekers onze
            website gebruiken. Deze informatie helpt ons de website te
            verbeteren.
          </p>

          <h3 className="font-bold text-[20px] text-[#17354A] mt-8 mb-4">
            Marketing cookies
          </h3>
          <p>
            Deze cookies worden gebruikt om advertenties relevanter te maken
            voor u en uw interesses. Ze worden ook gebruikt om het aantal keren
            dat u een advertentie ziet te beperken.
          </p>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Cookies beheren
          </h2>
          <p>
            U kunt uw cookievoorkeuren op elk moment aanpassen via de
            cookieinstellingen op onze website. Ook kunt u cookies verwijderen
            of blokkeren via uw browserinstellingen.
          </p>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Updates van dit beleid
          </h2>
          <p>
            We kunnen dit cookiebeleid van tijd tot tijd bijwerken. De meest
            recente versie is altijd beschikbaar op onze website.
          </p>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Contact
          </h2>
          <p>
            Heeft u vragen over ons cookiebeleid? Neem dan contact met ons op
            via:
          </p>
          <p className="mt-4">
            elektricieninarnhem026.nl
            <br />
            Laan van vollenhove 2935
            <br /> 3706 AK Zeist
            <br />
            info@elektricieninarnhem026.nl
          </p>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Cookies;
